module.exports = __webpack_public_path__ + "static/home-phone-layer-drivit-1a657758e0a89acb199d60b1c6a508b2.svg";